import data from './data.js';

/**
 * Get the response code associated with a specific error code.
 *
 * @param {string} errorCode - The error code for which the response code is needed.
 * @returns {string} The response code associated with the provided error code.
 */
function getResponseCode(errorCode) {
  return data[errorCode].code;
}
export default getResponseCode;